export default __webpack_public_path__ + "static/media/Juegos Comfama.6ab98735.png";